import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import AuthContext from 'src/contexts/AuthContext';
import { textPrimary, textInverse } from 'src/styles/colors';
import {
  accountNavigationItems, NAVIGATION_ACTIONS
} from './navigationConfig';

const AccountMenu = ({ inverted, onNavigate }) => {
  const { logout } = useContext(AuthContext);

  const linkStyle = {
    textDecoration: 'none',
    color: inverted ? textInverse : textPrimary,
  };

  return (
    <>
      {accountNavigationItems.map(item => (
        <Link
          key={item.label}
          to={item.to}
          className='menuLink'
          style={linkStyle}
          onClick={() => {
            if (item.action === NAVIGATION_ACTIONS.LOGOUT) logout();
            if (onNavigate) onNavigate();
          }}
        >
          {item.label}
        </Link>
      ))}
    </>
  );
};

export default AccountMenu;
